import React from 'react';
import PropTypes from 'prop-types';
import constants from 'src/constants';

const { CATEGORIES, MATERIALS } = constants.labels;

const SELECTED_LABELS_FOR_CATEGORIES = {
  [CATEGORIES.WALLS]: 'Facade',
  [CATEGORIES.ROOF]: 'Facet',
  [CATEGORIES.OPENINGS]: 'Opening',
};

const FacetAndFacadeCounter = ({ styles }) => {
  if (!styles) return null;

  const categoryCounts = styles.reduce((acc, { materialId, nodes }) => {
    const nodeCount = nodes.length;
    const material = MATERIALS[materialId];
    const { category } = material;
    acc[category] = acc[category] || 0;
    acc[category] += nodeCount;
    return acc;
  }, {});

  const summaries = Object.keys(categoryCounts).map((category) => {
    const count = categoryCounts[category];
    const baseWord = SELECTED_LABELS_FOR_CATEGORIES[category];
    const word = count > 1 ? `${baseWord}s` : baseWord;
    return `${count} ${word}`;
  });

  return summaries.join(', ');
};

FacetAndFacadeCounter.propTypes = {
  styles: PropTypes.array.isRequired,
};

export default FacetAndFacadeCounter;
